import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table";
import { vehicles } from "../../../../../../redux/vehicles/action";
import { selectVehiclesListItems } from "../../../../../../redux/vehicles/selector";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import useWindowDimensions from "../../../../../../hooks/useWindowsDimensions";
import MobileViewTable from "../../../../../../common/components/mobile-view-table.component";

const TransportAgentVehicles = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { height, width } = useWindowDimensions();
  const [pageData, setPageData] = useState(1)
  const itemsData = useSelector(selectVehiclesListItems)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'RegistrationNumber', headerName: 'Registration Number', sortable: true, filter: true, isEdit: true },
      { field: 'VehicleName', headerName: 'Vehicle Name', sortable: true, filter: true, },
      { field: 'LoadingCapacity', headerName: 'Loading Capacity' },
      { field: 'VehicleWeight', headerName: 'Vehicle Weight', sortable: false, filter: true },
    ]);
  }
  const fetchVehicls = () => {
    dispatch(vehicles.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/vehicle-registations/list`, entity: 'vehicles', jsonData: {
        "PageNumber": pageData,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }
  useEffect(() => {
    createColumnDefs()
    fetchVehicls()
  }, [pageData])
  const handleAdd = () => {
    navigate(`${0}`)
  }
  const handleDelete = (data: any) => {
    dispatch(vehicles.delete({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/vehicle-registations/delete`,
      entity: 'vehicles',
      jsonData: {
        Records: [
          {
            Id: data.Id
          }
        ]
      }
    })).then(() => {
      dispatch(vehicles.list({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/vehicle-registations/list`,
        entity: 'vehicles',
        jsonData: {}
      }));
    });
  }
  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }
  const additionButtons: any = [
    {
      name: 'Add Vehicle',
      callback: () => handleAdd(),
    }
  ];
  return (
    <>
      {itemsData?.isLoading ? <PageLoader />
        :

        <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData}
          paginationData={itemsData?.result?.pagination} onEdit={handleEdit} additionButtons={additionButtons} onDelete={handleDelete} headingName="Vehicles" />

      }
    </>
  );
};

export default TransportAgentVehicles;


